/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-10-14 15:46:25
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-12-16 18:28:54
 * @FilePath: \mall\src\utils\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export function setLocation(data) {
  sessionStorage.setItem('location', data)
}

export function getLocation() {
  return sessionStorage.getItem('location') || ''
}

const platformId = 'platformId'

export function getMainPlatform() {
  return localStorage.getItem('platformId') || ''
}

// 设置主平台
export function setMainPlatform(data) {
  localStorage.setItem('platformId', data)
}

// 设置主平台shopId
export function setPaltShopId(data) {
  localStorage.setItem('shopId', data)
}

export function getPaltShopId() {
  return localStorage.getItem('shopId') || ''
}

// 第一次登陆
export function setFirstLogin(type) {
  localStorage.setItem('FirstLogin', type)
}

export function getFirstLogin() {
  return localStorage.getItem('FirstLogin')
}

// 设置兑换信息
export function setExchangeCouponInfo(data) {
  const info = JSON.stringify(data)
  sessionStorage.setItem('exchangeCardInfo', info)
}

export function getExchangeCouponInfo() {
  const data =
    sessionStorage.getItem('exchangeCardInfo') || ''

  if (data) {
    return JSON.parse(data)
  }
  return ''
}

export function cleanExchangeCouponInfo() {
  sessionStorage.removeItem('exchangeCardInfo')
}
